import { ApiService } from "@/api";

export const updateBindUser = (sampleId: string, userId: string) => {
  return ApiService.baseAction(
    `/sample/update_user/${sampleId}`,
    {
      data: {
        userId: userId
      }
    },
    'post'
  )
}